import { render, staticRenderFns } from "./InternInfoViewV2.vue?vue&type=template&id=1a2a728e&"
import script from "./InternInfoViewV2.vue?vue&type=script&lang=js&"
export * from "./InternInfoViewV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports